import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getEntityCountryTypeCombo from '../../services/dossier/get/getEntityCountryTypeCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntityCountryTypeCombo ({ resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const combo = yield call(getEntityCountryTypeCombo, auth.token)
    if (resolve) {
      resolve(combo)
    } else {
      yield put(fetchCombosSuccess({ entityCountryTypeCombo: combo }))
    }
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchEntityCountryTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_ENTITY_COUNTRY_COMBO, fetchEntityCountryTypeCombo)
}
